import React, { Component } from 'react'
import { getUrl } from '../../../Api'
import axios from 'axios'
import { showDate, showMoney } from '../../../helpers'
import { Link } from 'react-router-dom'
import Delete from './List/Delete'
import { inString } from '../../../helpers'
import { getTrad } from '../../../lang'
import Filter from './List/Filter'
import ListBody from './List/ListBody'

function ListHeader() {
  return (
    <div className="card-header">
      <h2 className="card-title">{getTrad('pages.listDemandesBS')}</h2>
    </div>
  )
}

export default class Demandes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      listBS: [],
      matricule: '',
      adherant: '',
      presta: '',
      num_bs: '',
      date_bs: '',
    }
  }

  componentDidMount() {
    this.refresh()
  }

  cleanData = e => {
    return {
      ...e,
      bs_date: showDate(e.bs_date),
      depenses: showMoney(e.depenses),
      estimation: showMoney(e.estimation),
      action: (
        <div className="btn-group">
          <Link to={`/bultin-soins/${e.bs_number}/edit`} className="btn btn-secondary btn-sm">
            <i className="far fa-edit"></i>
          </Link>
          <Delete {...e} refresh={this.refresh} />
        </div>
      ),
    }
  }

  refresh = () => {
    this.setState({ loading: true }, () => {
      axios
        .get(getUrl('bs.demandes'))
        .then(res =>
          this.setState({ listBS: res.data.success.map(this.cleanData), loading: false })
        )
        .catch(() => this.setState({ listBS: [], loading: false }))
    })
  }

  filter = e => {
    if (!inString(this.state.matricule, e.matricule_adh)) return false
    if (!inString(this.state.adherant, e.full_name)) return false
    if (!inString(this.state.presta, e.prestataire)) return false
    if (!inString(this.state.num_bs, e.bs_number)) return false
    if (!inString(this.state.date_bs, e.bs_date)) return false

    return true
  }

  handleInput = event => this.setState({ [event.target.name]: event.target.value })

  render() {
    return (
      <div className="card">
        <ListHeader />
        <Filter
          matricule={this.state.matricule}
          adherant={this.state.adherant}
          presta={this.state.presta}
          num_bs={this.state.num_bs}
          date_bs={this.state.date_bs}
          handler={this.handleInput}
        />
        <ListBody loading={this.state.loading} data={this.state.listBS.filter(this.filter)} />
      </div>
    )
  }
}
